/**
 * URL del Central System que se carga en el cargador (RB-00). Se deriva del origen de la API del
 * ambiente: `api[-env].<dominio>` → `ocpp[-env].<dominio>` (nombres de host de Terraform, locals.tf).
 * Sin API configurada (desarrollo con proxy) o con un origen que no sigue ese patrón se muestra la
 * de producción.
 */
const PRODUCTION_OCPP_HOST = 'ocpp.supercargadores.co';

export function ocppUrlFor(apiBaseUrl: string, chargeBoxId: string): string {
  return `wss://${ocppHostFor(apiBaseUrl)}/ocpp/${chargeBoxId}`;
}

export function ocppHostFor(apiBaseUrl: string): string {
  let apiHost: string;
  try {
    apiHost = new URL(apiBaseUrl).hostname.toLowerCase();
  } catch {
    return PRODUCTION_OCPP_HOST;
  }
  if (apiHost.endsWith('.run.app')) return PRODUCTION_OCPP_HOST;
  const match = /^api(-[a-z0-9]+)?\.([a-z0-9.-]+)$/.exec(apiHost);
  if (!match?.[2]) return PRODUCTION_OCPP_HOST;
  return `ocpp${match[1] ?? ''}.${match[2]}`;
}
